export const addEcommerceDependencies = (isCheckoutProdVersion, ecommerceProps) => {
  const scriptElement = document.createElement('script');
  scriptElement.src = isCheckoutProdVersion
    ? ecommerceProps.paymentMethods.niubiz.cdnProdWebMode.paymentPopUp
    : ecommerceProps.paymentMethods.niubiz.cdnTestWebMode.paymentPopUp;
  document.head.appendChild(scriptElement);
};
